"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarProvider = SnackbarProvider;

var _reactTransitionGroup = require("react-transition-group");

var _snackbarContext = require("./snackbar-context");

var _snackbarMessage = require("./snackbar-message");

var _styledTools = require("styled-tools");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Action types.
 */
var actionTypes = {
  addMessage: 'ADD_MESSAGE',
  removeMessage: 'REMOVE_MESSAGE'
};
/**
 * Reducer.
 */

function reducer(state, action) {
  switch (action.type) {
    case actionTypes.addMessage:
      {
        var _action$payload2;

        var total = state.total + 1;
        var messages = state.messages.filter(function (_ref) {
          var _action$payload, _action$payload$messa;

          var content = _ref.content;
          return content !== ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : (_action$payload$messa = _action$payload.message) === null || _action$payload$messa === void 0 ? void 0 : _action$payload$messa.content);
        });
        return {
          messages: [].concat(_toConsumableArray(messages), [_objectSpread(_objectSpread({}, (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.message), {}, {
            id: total
          })]),
          total: total
        };
      }

    case actionTypes.removeMessage:
      return {
        messages: state.messages.filter(function (_ref2) {
          var id = _ref2.id;
          return id !== action.payload.id;
        }),
        total: state.total - 1
      };

    default:
      return state;
  }
}
/**
 * Snackbar transition time.
 */


var snackbarTransitionTime = 255;
/**
 * `Wrapper` styled component.
 */

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "snackbar-provider__Wrapper",
  componentId: "sc-1wk0ytk-0"
})(["left:8px;margin:0 auto;max-width:", "px;position:fixed;right:8px;top:8px;z-index:", ";.snackbar-messages-item-enter{opacity:0;transform:translateY(8px);}.snackbar-messages-item-enter-active{opacity:1;transform:translateY(0);transition:opacity ", "ms ", ",transform 0.15s ", ";}.snackbar-messages-item-exit{opacity:1;}.snackbar-messages-item-exit-active{opacity:0;transition:opacity ", "ms ", ";}"], (0, _styledTools.theme)('dimensions.snackbar.maxWidth'), (0, _styledTools.theme)('zIndex.snackbar'), snackbarTransitionTime, (0, _styledTools.theme)('animations.bezier.easeInOutQuad'), (0, _styledTools.theme)('animations.bezier.easeInOutQuad'), snackbarTransitionTime, (0, _styledTools.theme)('animations.bezier.easeInOutQuad'));
/**
 * Export `SnackbarProvider` component.
 */


function SnackbarProvider(_ref3) {
  var children = _ref3.children;

  var _useReducer = (0, _react.useReducer)(reducer, {
    messages: [],
    total: 0
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      messages = _useReducer2[0].messages,
      dispatch = _useReducer2[1];

  var showMessage = (0, _react.useCallback)(function (content, options) {
    dispatch({
      payload: {
        message: {
          content: content,
          options: options
        }
      },
      type: actionTypes.addMessage
    });
  }, []);
  var snackbarActions = (0, _react.useMemo)(function () {
    return {
      showErrorMessage: function showErrorMessage(content, options) {
        showMessage(content, _objectSpread(_objectSpread({}, options), {}, {
          type: 'error'
        }));
      },
      showInfoMessage: function showInfoMessage(content, options) {
        showMessage(content, _objectSpread(_objectSpread({}, options), {}, {
          type: 'info'
        }));
      },
      showSuccessMessage: function showSuccessMessage(content, options) {
        showMessage(content, _objectSpread(_objectSpread({}, options), {}, {
          type: 'success'
        }));
      },
      showWarningMessage: function showWarningMessage(content, options) {
        showMessage(content, _objectSpread(_objectSpread({}, options), {}, {
          type: 'warning'
        }));
      }
    };
  }, [showMessage]);
  var removeMessage = (0, _react.useCallback)(function (id) {
    dispatch({
      payload: {
        id: id
      },
      type: actionTypes.removeMessage
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_snackbarContext.SnackbarContext.Provider, {
    value: snackbarActions
  }, children, /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.TransitionGroup, null, messages.map(function (_ref4) {
    var content = _ref4.content,
        id = _ref4.id,
        options = _ref4.options;
    return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
      classNames: 'snackbar-messages-item',
      key: id,
      timeout: snackbarTransitionTime
    }, /*#__PURE__*/_react["default"].createElement(_snackbarMessage.SnackbarMessage, {
      id: id,
      onRemove: removeMessage,
      options: options
    }, content));
  }))));
}